var map = {
	"./activity.js": "0zX9",
	"./appeal.js": "L8dW",
	"./appraiseElect.js": "rWhI",
	"./approval.js": "s74A",
	"./arms.js": "ImBt",
	"./attendance.js": "lmSk",
	"./closedLoopSubmitted.js": "20PL",
	"./configuration.js": "+6CR",
	"./consult.js": "ZiCs",
	"./counseling.js": "XEkx",
	"./difficultStudent.js": "Gymi",
	"./dorm.js": "BtFk",
	"./evaluation.js": "OhvJ",
	"./formConfiguration.js": "qktx",
	"./graduatesLeavingBed.js": "2eJV",
	"./instructor.js": "iryZ",
	"./main.js": "zuab",
	"./nationalGrants.js": "jvOo",
	"./notice.js": "9HqQ",
	"./other.js": "2wu/",
	"./program.js": "t040",
	"./punishment.js": "PDgo",
	"./questionnaire.js": "NaQO",
	"./report.js": "gLZT",
	"./student.js": "UNwt",
	"./studentInsurance.js": "1Arx",
	"./systemSettings.js": "2LxZ",
	"./welcomeNewStudent.js": "bAUU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lz2Q";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules nonrecursive [\w-]+\.js$
// module id = lz2Q
// module chunks = 227